/** Cadenas des cartes et nœuds verrouillés (classes du menu de choix, talents du hub). */
export const Padlock = ({ class: cls = 'class-lock', size = 28 }: { class?: string; size?: number }) => (
  <svg class={cls} viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
    <path d="M7 10V7a5 5 0 0 1 10 0v3" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
    <rect x="4.5" y="10" width="15" height="11" rx="2.2" fill="currentColor" />
    <circle cx="12" cy="15.2" r="1.7" fill="#1b140c" />
  </svg>
);
